import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface EmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (email: string, quantity: number) => void;
  title?: string;
  maxTickets?: number;
}

const EmailModal: React.FC<EmailModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  maxTickets = 5
}) => {
  const [email, setEmail] = useState("");
  const [quantity, setQuantity] = useState(1);
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      onSubmit(email.trim(), quantity);
      setEmail("");
      setQuantity(1);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center">
      <div className="bg-gradient-to-b from-black/70 via-zinc-900/80 to-zinc-800/90 text-white p-8 rounded-2xl max-w-md w-full shadow-2xl relative border border-white/20">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-2xl hover:text-brand-red-text cursor-pointer"
        >
          ×
        </button>

        <h2 className="text-2xl font-bold mb-6 text-center">
          {title || t("emailModal.title")}
        </h2>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label htmlFor="email" className="block text-sm font-semibold text-gray-200 mb-1">
              {t("emailModal.email")} *
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
              className="w-full bg-zinc-800 border border-zinc-600 text-white rounded px-4 py-2 placeholder-gray-400"
              placeholder={t("emailModal.emailPlaceholder")}
            />
          </div>

          <div>
            <label htmlFor="quantity" className="block text-sm font-semibold text-gray-200 mb-1">
              Adet *
            </label>
            <select
              id="quantity"
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value))}
              className="w-full bg-zinc-800 border border-zinc-600 text-white rounded px-4 py-2"
            >
              {Array.from({ length: maxTickets }, (_, i) => i + 1).map(num => (
                <option key={num} value={num}>{num} Bilet</option>
              ))}
            </select>
          </div>

          <button
            type="submit"
            className="bg-[#D8001D] hover:bg-[#B8001A] text-white py-2 rounded font-semibold w-full cursor-pointer"
          >
            {t("emailModal.submit")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmailModal; 